import {
  PALETTE_CLASS_TEMPLATE,
  PALETTE_COLOR_TOKEN,
} from "@/src/design_system/shared_modules/palette/constants/palette";
import { DSColorPalette } from "@/src/design_system/shared/types/colorPalette.generated";

export const getPaletteClass = (color?: DSColorPalette | null) =>
  color ? PALETTE_CLASS_TEMPLATE.replace(PALETTE_COLOR_TOKEN, color) : "";
